<script>
/**
 * Name         : RegiConsolForm
 * Type         : Modal component
 * Title        : console 등록 컴포넌트
 * Description  : 
 * 
 */

export default {
  name: "RegiConsolForm",
  props: {
    mode: {
      type: [String, Number],
      default: 0 // 0: add, 1: modify
    },
    title: {
      type: String,
      default: "콘솔 등록"
    },
    consolInfo: {
      type: Object,
      default: () => ({})
    }
  },
  emits:[
    "close-modal",
    "refresh-list" // 콘솔 목록을 새로고침하기 위한 이벤트
  ],
  data() {
    return {
      freightCode : this.consolInfo.freightCode || "",
      mblNo       : this.consolInfo.mblNo || "",
      etd         : this.consolInfo.etd || "",
      eta         : this.consolInfo.eta || "",
      departCity  : this.consolInfo.departCity || "",
      arrivalCity : this.consolInfo.arrivalCity || "",
      status      : this.consolInfo.status || "001",
      memo        : this.consolInfo.memo || "",

      freightList : [],
    }
  },
  methods : {
    /**
     * Title        : 콘솔 등록하기
     * Status       : Actived
     * Description  : backend API 호출로 콘솔 등록.
     */
    async registerConsol() {

      try {
        let payload = {
          freightCode : this.freightCode,
          mblNo       : this.mblNo,
          etd         : this.etd,
          eta         : this.eta,
          departCity  : this.departCity,
          arrivalCity : this.arrivalCity,
          status      : this.status,
          memo        : this.memo,
        };

        let config = {
          method  : "POST",
          data    : payload,
          url     : "/api/consol/registerConsol",
          name    : "[ Axios / registerConsol / 신규 콘솔 등록 ]"
        }

        await this.$http(config)
          .then((res) => {
            this.$log.debug(`${config.name} 성공 => `, res.data)
            this.$emit("close-modal")
            this.$emit("refresh-list") // 콘솔 목록 새로고침 이벤트 발생
          })
          .catch((err) => {
            this.$log.debug(err)
            alert(`${config.name} 실패!`)
        })
      } catch (error) {
        this.$q.notify({
          type: 'negative',
          message: `에러 발생: ${error.response?.data?.message || error.message}`,
        });
      }
    },


    /**
     * Title        : 콘솔 수정하기
     * Status       : Actived
     * Description  : backend API 호출로 콘솔 수정.
     */
    async modifyConsol() {

      try {
        let payload = {
          id          : this.consolInfo.id, // 콘솔 ID
          freightCode : this.freightCode,
          mblNo       : this.mblNo,
          etd         : this.etd,
          eta         : this.eta,
          departCity  : this.departCity,
          arrivalCity : this.arrivalCity,
          status      : this.status,
          memo        : this.memo,
        };

        let config = {
          method  : "POST",
          data    : payload,
          url     : "/api/consol/modifyConsol",
          name    : "[ Axios / modifyConsol / 콘솔 수정 ]"
        }

        await this.$http(config)
          .then((res) => {
            this.$log.debug(`${config.name} 성공 => `, res.data)
            alert(`콘솔 수정에 성공했습니다.`)
            this.$emit("close-modal")
            this.$emit("refresh-list") // 콘솔 목록 새로고침 이벤트 발생
          })
          .catch((err) => {
            this.$log.debug(err)
            alert(`${config.name} 실패!`)
        })
      } catch (error) {
        alert(`에러 발생: ${error.response?.data?.message || error.message}`)
      }
    },

    /**
     * Title        : 운송편 목록 조회
     * Status       : Actived
     * Description  : 운송편 목록을 조회한다.
     */
    async loadFreightList() {

      let result = []

      let config = {
        method  : "get",
        url     : "/api/freight/getFreightList",
        name    : "[ Axios / loadFreightList / 운송편 목록 호출 ]"
      }

      result = await this.$http(config)
        .then(res => {
          let tempRtn = res.data

          tempRtn.forEach((item) => {
            item.label = item.freightNo + " (" + item.departure + " - " + item.arrival + ")"
            item.value = item.freightNo
          })
          return tempRtn
        })

      this.freightList = result
    },

    /**
     * Title        : 초기화
     * Status       : Actived
     * Description  : 컴포넌트 초기화
     */
    async init(){
      await this.$getCodeList("CIT")
      await this.$getCodeList("CONSTT")
      await this.loadFreightList()
    }
  },
  async mounted() {
    this.$log.info("[ Component / RegiConsolForm ]")
    await this.init()
  },
}
</script>

<template>

  <q-card style="width: 700px; max-width: 80vw;">
    <q-card-section>
      <div class="row justify-between">
        <div class="text-h6">
          {{ title }}
        </div>
        <div>
          <q-btn
            flat v-close-popup round dense icon="close" />
        </div>
      </div>
      <div></div>
    </q-card-section>
    <q-card-section class="q-pt-none">
      <div class="row q-mb-sm q-gutter-sm">
        <div class="col">

          <q-select
            v-model="freightCode"
            label="운송편명(선명)"
            :options="this.freightList"
            emit-value
            map-options
            behavior="menu"
            placeholder="ex) AUS, KOR"/>
          
        </div>
        <div class="col">

          <q-input 
            v-model="mblNo"
            :maxlength="14"
            label="M B/L No." />    

        </div>
      </div>
      
      <div class="row q-gutter-sm">
        <div class="col">
          <q-select
            v-model="departCity"
            label="출발지"
            :options="this.$store.getters.getCityCodeList"
            emit-value
            map-options
            behavior="menu"
            placeholder="ex) AUS, KOR"
          />
        </div>
        <div class="col">
          <q-select
            v-model="arrivalCity"
            label="도착지"
            :options="this.$store.getters.getCityCodeList"
            emit-value
            map-options
            behavior="menu"
            placeholder="ex) SYD, BRN"
          />
        </div>
        
        <div class="col">
          <q-select
            v-model="status"
            label="콘솔상태"
            :options="this.$store.getters.getConsolStatusList"
            emit-value
            map-options
            behavior="menu"
            placeholder="ex) CBD, HOM"
          />
        </div>
      </div>
      <div class="row q-gutter-sm">
        <div class="col">

          <q-input
            v-model="etd"
            label="출발일자">
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer" @click="$refs.estimateTimeDepart.show()" />
            </template>
            <q-popup-proxy ref="estimateTimeDepart" transition-show="scale" transition-hide="scale">
              <q-date 
                v-model="etd" 
                mask="YYYY-MM-DD" 
                format24h
                @input="$refs.estimateTimeDepart.hide()" />
            </q-popup-proxy>
          </q-input>

        </div>
        <div class="col">

          <q-input
            v-model="eta"
            label="도착일자">
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer" @click="$refs.estimateTimeArrive.show()" />
            </template>
            <q-popup-proxy ref="estimateTimeArrive" transition-show="scale" transition-hide="scale">
              <q-date 
                v-model="eta" 
                mask="YYYY-MM-DD" 
                format24h
                @input="$refs.estimateTimeArrive.hide()" />
            </q-popup-proxy>
          </q-input>

        </div>
      </div>
      <div class="row q-gutter-sm">
        <div class="col">
          <q-input 
            v-model="memo"
            type="textarea"
            label="콘솔 비고 메모"
            maxlength="400"
            placeholder="콘솔에 대한 메모를 남겨주세요."/>
        </div>
      </div>
    </q-card-section>
    <q-footer class="bg-white text-black">
      <q-toolbar>
        <q-btn
          v-if="mode === 'add'"
          label="콘솔추가"
          class="full-width"
          color="primary"
          @click="registerConsol">
        </q-btn>
        <q-btn
          v-if="mode === 'modify'"
          label="콘솔수정"
          class="full-width"
          color="primary"
          @click="modifyConsol">
        </q-btn>
      </q-toolbar>
    </q-footer>
  </q-card>
</template>
